import { NAV_HUB_CARD_IMAGES } from './navHubCardImages';

export const IMG2IMG_PROMPT_MAX_LENGTH = 500;

/** 每张参考图（或无图仅文案）固定产出张数；侧栏不再提供生成数量选择 */
export const IMG2IMG_OUTPUT_PER_SOURCE = 1;

// 侧栏「指令案例」硬编码已下线；官方种子见 Flyway V20260726120000__ai_img2img_prompt_case.sql

export const IMG2IMG_HERO_DEMO = {
  image: NAV_HUB_CARD_IMAGES.img2img.result,
  caption: '商品改为蓝色，背景为海滩',
};

/** 空态「或者用案例试试」仅展示官方模板封面，最多 3 个 */
export const IMG2IMG_TRY_OFFICIAL_LIMIT = 3;
